import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { config } from 'config'

export default class About extends React.Component {
  render () {
    return (
      <div className="page">
        <Helmet
          title={'About • ' + config.siteTitle}
          meta={[
            {"name": "description", "content": "Hi, my name is Chris Jennings and I am the co-founder / designer of Sentry.io in San Francisco."},
            {"name": "keywords", "content": "about, ckj, sentry, github, disqus"},
          ]}
        />
        <h1>
          i design & build dev tools
        </h1>
        <hr/>
        <p><strong>Hi, my name is Chris Jennings and I am a co-founder and designer at Sentry.io in San Francisco.</strong></p>
        <p>Previously I was a product designer at <a href="http://github.com">GitHub</a>, where I helped design issue and pull request conversation timelines. before that, I was Director of Design at <a href="http://github.com">Disqus</a> where I led design on the last three generations of the comment interface, including the version that's live right now.</p>
        <p>I am a husband and father of two. In my spare time I enjoy doing dope dad shit, reading comic books, playing Starsiege: Tribes, and tinkering on side projects.</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./about.js